<template>
    <div class="popularize-box">
        <populist @getChild="setFather" :popu="popu" :searchData="searchData" :searchTitle="searchTitle" :searchUrl="searchUrl" :isAjax="isAjax" v-show="isShowList" :refresh="refresh"></populist>
        <popu @getPopuChild="setFather" :searchUrl="searchUrl" :popu="popu"  v-show="!isShowList"></popu>
    </div>
</template>

<script>
    import populist from "./popuList"
    import popu from "./popu"

    export default {
        name:"popularize-box",
        props:['init'],
        data(){
            return {
                isShowList:true,
                searchData:[{name:"渠道媒介名称",value:""},{name:"渠道媒介标识",value:""}],
                searchTitle:[{name:"渠道组"},{name:"渠道媒介"},{name:"资源名字"},{name:"url链接"},{name:"关键词"}],
                searchUrl:`${webUrl}/resource/`,
                popu:"",
                refresh:false,
                isAjax:false
            }
        },
        watch:{
            "init":function(val){
                if(val == '12'){
                    this.refresh = !this.refresh;
                }
                this.isShowList=true;
            }
        },
        mounted(){
        },
        methods:{
            setFather(val){
                // popu页面返回不加在select
                if(!val){
                    $.ajax({
                        url:`${webUrl}/resource/getSelect`,
                        headers: {
                            'Auth-Token' : localStorage.getItem("token")
                        },
                        type:"POST",
                        dataType:"JSON",
                        success:(res)=>{
                            this.popu = res.data;
                        }
                    })
                }
                // 新增成功 返回加载getData
                if(val == 2){
                    this.isAjax = !this.isAjax
                }
                // 判断是新增还是编辑
                if(val){
                    this.isShowList = true;
                }else{
                    this.isShowList = false
                }
            }
        },
        components:{
            populist:populist,
            popu:popu
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/main/popularizeBox.vue